import CustomTypography from 'components/ui-kit/Typography/index'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import * as Sentry from '@sentry/react'

class ErrorBoundary extends Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError (error) {
    // Report the error to Sentry
    Sentry.captureException(error)
    return { hasError: true }
  }

  componentDidCatch (error, errorInfo) {
    // Log additional error information to Sentry
    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo)
      Sentry.captureException(error)
    })
  }

  render () {
    const { t } = this.props
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <CustomTypography
          fontSizeClass='fs-2'
          fontWeightClass='fw-700'
          textAlignClass='text-center'
          component='div'
          otherStyleClasses='mt-50'
        >
          {t('somethingWentWrong')}
        </CustomTypography>
      )
    }

    return this.props.children
  }
}

// Create a separate fallback component to handle translations
const ErrorFallback = withTranslation()(({ t }) => (
  <CustomTypography
    fontSizeClass='fs-2'
    fontWeightClass='fw-700'
    textAlignClass='text-center'
    component='div'
    otherStyleClasses='mt-50'
  >
    {t('somethingWentWrong')}
  </CustomTypography>
))

// Wrap the component with Sentry's error boundary
export default Sentry.withErrorBoundary(withTranslation()(ErrorBoundary), {
  fallback: () => <ErrorFallback />
})
